import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncPhosphorIconDuotone = createAsyncIcon(() => import('./PhosphorIconDuotone'));

export default AsyncPhosphorIconDuotone;

AsyncPhosphorIconDuotone.displayName = 'AsyncPhosphorIconDuotone';
